module.exports = __webpack_public_path__ + "img/suggest-banner.d8fefa5e.webp";